/* =========================================
StudentTc.jsx
========================================= */

import React, {
  useEffect,
  useState
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { useNavigate } from "react-router-dom";

const StudentTc = () => {
  const [open, setOpen] =
    useState(false);

  const [sessions, setSessions] =
    useState([]);

  const navigate =
    useNavigate();

  useEffect(() => {
    fetch(
      "https://kasiaweb.ilakshyaerp.in/api/student-tc/sessions"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setSessions(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, []);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <div className="about-hero">
        <div className="about-overlay">
          <h1>
            STUDENT TC
          </h1>

          <Breadcrumb />
        </div>
      </div>

      <div className="container">

        <div className="gallery-section">
          <h2 className="gallery-title">
            Academic Sessions
          </h2>
        </div>

        {/* SESSION GRID */}
        <div className="life-grid">

          {sessions.map(
            (item) => (
              <div
                key={item.id}
                className="life-card"
                onClick={() =>
                  navigate(
                    `/student-tc/session/${item.id}`
                  )
                }
              >
                <div className="tc-session-box">

                  <h2>
                    {
                      item.session_name
                    }
                  </h2>

                  <p>
                    View Classes
                  </p>

                </div>
              </div>
            )
          )}

        </div>

      </div>

      <Footer />
    </>
  );
};

export default StudentTc;